"use strict";

exports.__esModule = true;
exports["default"] = exports.commentProps = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _ButtonLike = _interopRequireDefault(require("../ButtonLike/ButtonLike"));

var _IconCount = _interopRequireDefault(require("../IconCount/IconCount"));

var _CommentContent = _interopRequireDefault(require("./CommentContent"));

var _CommentEdit = _interopRequireDefault(require("./CommentEdit"));

var _CommentFooter = _interopRequireDefault(require("./CommentFooter"));

var _CommentPanel = _interopRequireDefault(require("./CommentPanel"));

var _CommentText = _interopRequireDefault(require("./CommentText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CommentsIcon = function CommentsIcon(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
  }));
};

CommentsIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
};

var ThumbsUpIcon = function ThumbsUpIcon(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
  }));
};

ThumbsUpIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var Comment = function Comment(_ref) {
  var loggedInUserIsAuthor = _ref.loggedInUserIsAuthor,
      authorName = _ref.authorName,
      authorAvatarUrl = _ref.authorAvatarUrl,
      timeAgo = _ref.timeAgo,
      commentText = _ref.commentText,
      numberOfLikes = _ref.numberOfLikes,
      likedByUser = _ref.likedByUser,
      editing = _ref.editing,
      editFormValue = _ref.editFormValue,
      editFormValidationMessage = _ref.editFormValidationMessage,
      submittingEdit = _ref.submittingEdit,
      editFormId = _ref.editFormId,
      onClickEdit = _ref.onClickEdit,
      onClickSubmitEdit = _ref.onClickSubmitEdit,
      onClickCancelEdit = _ref.onClickCancelEdit,
      onClickDelete = _ref.onClickDelete,
      onClickLike = _ref.onClickLike,
      onChangeEditForm = _ref.onChangeEditForm,
      onKeyDownEditForm = _ref.onKeyDownEditForm,
      isStatic = _ref.isStatic,
      numberOfReplies = _ref.numberOfReplies,
      hideFooterCommands = _ref.hideFooterCommands,
      props = _objectWithoutPropertiesLoose(_ref, ["loggedInUserIsAuthor", "authorName", "authorAvatarUrl", "timeAgo", "commentText", "numberOfLikes", "likedByUser", "editing", "editFormValue", "editFormValidationMessage", "submittingEdit", "editFormId", "onClickEdit", "onClickSubmitEdit", "onClickCancelEdit", "onClickDelete", "onClickLike", "onChangeEditForm", "onKeyDownEditForm", "isStatic", "numberOfReplies", "hideFooterCommands"]);

  return (0, _themeUi.jsx)(_CommentPanel["default"], _extends({}, props, {
    avatarUrl: authorAvatarUrl
  }), editing ? (0, _themeUi.jsx)(_CommentEdit["default"], {
    id: editFormId,
    onClickSubmit: onClickSubmitEdit,
    onClickCancel: onClickCancelEdit,
    onChange: onChangeEditForm,
    onKeyDown: onKeyDownEditForm,
    submitting: submittingEdit,
    value: editFormValue,
    validationMessage: editFormValidationMessage
  }) : (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)(_CommentContent["default"], null, (0, _themeUi.jsx)(_CommentText["default"], {
    authorName: authorName
  }, commentText), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      flexShrink: 0,
      flexGrow: 0
    }
  }, numberOfReplies >= 0 && (0, _themeUi.jsx)(_IconCount["default"], {
    count: numberOfReplies,
    icon: CommentsIcon,
    sx: {
      color: 'textMediumEmphasis'
    }
  }), (0, _themeUi.jsx)("div", {
    sx: {
      borderLeftWidth: 'thin',
      borderLeftStyle: 'solid',
      borderColor: 'neutral.1',
      ml: 1,
      mr: '2px'
    }
  }), isStatic ? (0, _themeUi.jsx)(_IconCount["default"], {
    count: numberOfLikes,
    icon: ThumbsUpIcon,
    sx: {
      color: 'textMediumEmphasis'
    }
  }) : (0, _themeUi.jsx)(_ButtonLike["default"], {
    count: numberOfLikes,
    active: likedByUser,
    disabled: loggedInUserIsAuthor,
    onClick: onClickLike
  }))), (0, _themeUi.jsx)(_CommentFooter["default"], {
    timeAgo: timeAgo,
    deleteDisabled: numberOfLikes > 0,
    hideFooterCommands: hideFooterCommands,
    onClickEdit: loggedInUserIsAuthor ? onClickEdit : null,
    onClickDelete: loggedInUserIsAuthor ? onClickDelete : null
  })));
};

var commentProps = {
  id: _propTypes["default"].string,
  loggedInUserIsAuthor: _propTypes["default"].bool,
  authorName: _propTypes["default"].string,
  authorAvatarUrl: _propTypes["default"].string,
  timeAgo: _propTypes["default"].string,
  commentText: _propTypes["default"].string,
  numberOfLikes: _propTypes["default"].number,
  likedByUser: _propTypes["default"].bool,
  editing: _propTypes["default"].bool,
  editFormValue: _propTypes["default"].string,
  editFormValidationMessage: _propTypes["default"].string,
  submittingEdit: _propTypes["default"].bool,
  editFormId: _propTypes["default"].string,
  onClickEdit: _propTypes["default"].func,
  onClickSubmitEdit: _propTypes["default"].func,
  onClickCancelEdit: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func,
  onClickLike: _propTypes["default"].func,
  onChangeEditForm: _propTypes["default"].func,
  onKeyDownEditForm: _propTypes["default"].func,
  numberOfReplies: _propTypes["default"].number,
  isStatic: _propTypes["default"].bool,
  hideFooterCommands: _propTypes["default"].bool
};
exports.commentProps = commentProps;
Comment.propTypes = commentProps;
Comment.defaultProps = {
  loggedInUserIsAuthor: false,
  likedByUser: false,
  editing: false,
  submittingEdit: false,
  isStatic: false,
  hideFooterCommands: false
};
var _default = Comment;
exports["default"] = _default;